import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { IBranch } from "src/app/interfaces/branch";

@Component({
  selector: "app-placement-reservation",
  templateUrl: "./placement-reservation.component.html",
  styleUrls: ["./placement-reservation.component.css"]
})
export class PlacementReservationComponent implements OnInit {
  branchList: IBranch[];

  constructor(
   public translate: TranslateService
  ) {}

  ngOnInit() {}
}
